export default __webpack_public_path__ + "static/media/botblack.27d0986f.png";